module.exports = {"451024100":"城关镇","451024101":"足荣镇","451024102":"隆桑镇","451024103":"敬德镇","451024104":"马隘镇","451024105":"东凌镇","451024106":"那甲镇","451024200":"都安乡","451024203":"荣华乡","451024204":"燕峒乡","451024205":"龙光乡","451024206":"巴头乡","451024450":"德保铝业"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451024.json
// module id = 1970
// module chunks = 0